module.exports = __webpack_public_path__ + "static/media/logo.ef1c1594.png";